/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagRightIcon24Regular = forwardRef('ArrowDim1DiagRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.5 2.25a.75.75 0 0 0 0 1.5h5.69L3.75 19.19V13.5a.75.75 0 0 0-1.5 0v6.25a2 2 0 0 0 2 2h6.25a.75.75 0 0 0 0-1.5H4.81L20.25 4.81v5.69a.75.75 0 0 0 1.5 0V4.25a2 2 0 0 0-2-2H13.5Z" })));
});
